module.exports = __webpack_public_path__ + "img/profile.ff528c5b.jpg";